import { getService } from '../../utils';

export const getRobotsService = getService('robots');
